import { render, staticRenderFns } from "./WaitingForApproval.vue?vue&type=template&id=7deb27da&scoped=true"
import script from "./WaitingForApproval.vue?vue&type=script&lang=js"
export * from "./WaitingForApproval.vue?vue&type=script&lang=js"
import style0 from "./WaitingForApproval.vue?vue&type=style&index=0&id=7deb27da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb27da",
  null
  
)

export default component.exports